import { useState } from "react";
import axios from "axios";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";

const useAttendance = () => {
  const [btnSubmit, setBtnSubmit] = useState(true);
  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const checkIn = () => {
    const checkInTime = new Date().toISOString();
    const attendanceDate = moment(new Date()).format("YYYY-MM-DD");
    const formData = new FormData();
    formData.append("staffId", localStorage.getItem("staffId"));
    formData.append("attendanceDate", attendanceDate);
    formData.append("checkIn", checkInTime);

    setBtnSubmit(false);
    axios
      .post(config.APIACTIVATEURL + config.STAFFCHECKIN, formData, headerconfig)
      .then((response) => {
        if (response.data.statusCode === 200) {
          handleSuccess(response.data.data);
        } else {
          handleError(response.data.data);
        }
      });
  };

  const checkOut = () => {
    const checkOutTime = new Date().toISOString();
    const attendanceDate = moment(new Date()).format("YYYY-MM-DD");
    const formData = new FormData();
    formData.append("staffId", localStorage.getItem("staffId"));
    formData.append("attendanceDate", attendanceDate);
    formData.append("checkOut", checkOutTime);

    setBtnSubmit(false);
    axios
      .put(config.APIACTIVATEURL + config.STAFFCHECKOUT, formData, headerconfig)
      .then((response) => {
        if (response.data.statusCode === 200) {
          handleSuccess(response.data.data);
        } else {
          handleError(response.data.data);
        }
      });
  };

  return { checkIn, checkOut, btnSubmit };
};

export default useAttendance;
